export const zh = {
  language: '语言',
  serverName: 'TVU云调度',
  view: '视图',
  gridL: '宫格视图',
  listL: '列表视图',
  Source: '源',
  createS: '最近创建',
  activeS: '播放优先',
  editS: '最近编辑',
  alpS: '字母',
  Relational: '关联排序', // 中文翻译 [Claude Code]
  source: '源',
  sourceType: '源类型',
  filter: '筛选',
  search: '搜索',
  clearA: '清除所有',
  gridPack: 'Grid背包',
  tvuPack: 'TVU背包',
  ext: '外部源',
  tag: '标签',
  inputType: '输入源类型',
  Project: '项目',
  liveS: '推流优先',
  name: '名称',
  xy: 'X/Y监控',
  managePay: '支付管理',
  planPay: '支付套餐',
  planM: '套餐管理',
  preview: '预览',
  record: '录制',
  recordNotSupported: '当前不支持录制功能',
  noDesc: '无描述',
  notLive: '未推流',
  noTag: '无标签',
  projectIna: '无推流',
  scope: '调色',
  Scope: '调色',
  stop: '停止',
  stopping: '停止中',
  sourceName: '源名称',
  sourceNameEmpty: '请输入源名称',
  outputProject: '推流项目',
  to: '至',
  status: '状态',
  all: '所有',
  live: '推流中',
  ended: '已结束',
  startTime: '开始时间（本地时间）',
  stopTime: '结束时间（本地时间）',
  duration: '时长',
  health: '状态/健康',
  total: '共X条',
  page: '页',
  goto: '前往',
  ok: '确认',
  clear: '清空',
  outputType: '输出类型',
  quickSetup: '快速设置',
  tvuDevice: 'TVU设备',
  zoom: 'Zoom会议',
  tiktok: '抖音',
  enterU: '输入URL',
  entUText: '输入此源的视频流的URL',
  eg: '例',
  disableSaveTip: '推流时不能编辑/删除。请先停止推流以进行更改。',
  disableEditTip: '你没有权限对当前源进行编辑。',
  save: '保存',
  cancel: '取消',
  apply: '应用',
  avail: '可用',
  occ: '已占用',
  peeIdOrName: 'PeerID或名称',
  projectIdOrName: 'ProjectID或名称',
  type: '类型',
  deviceName: '设备名称',
  deviceType: '设备类型',
  devicePID: '设备PID',
  bit: '比特率',
  fps: '帧率',
  resolution: '分辨率',
  created: '创建时间',
  mediaAnalyzerLite: 'Media Analyzer Lite',
  mediaAnalyzer: 'Media Analyzer',
  videoTitle: '视频',
  audioTitle: '音频',
  maNoData: 'No Data',
  lat: '延迟',
  server: '服务器',
  domainT: '域名/IP',
  desc: '描述',
  location: '位置',
  personal: '个人',
  group: '组',
  pushTo: '推流到云调度',
  pullTo: '拉流到云调度',
  streamU: '流URL',
  streamK: '流密钥',
  generate: '获取',
  urlTip: 'URL中该值以微秒为单位显示',
  moreO: '更多参数',
  more: '更多',
  passphrase: '密钥',
  passphraseTip: '输入10-79位字符',
  manual: '手动输入',
  discovery: '查找服务器',
  noServer: '无服务器',
  hostMName: '主机名',
  streamName: '流名称',
  invitationParser: '邀请解析',
  meetingId: '会议ID',
  meetingCode: '会议密码',
  meetingCodeT: '请输入正确的会议密码',
  boot: '录制机器名称',
  bootPlaceholder: '输入录制机器名称',
  bootT: '加入Zoom会议的录制机器的名称。<br/>自定义它以帮助您的团队识别和批准<br/>机器更容易。',
  partyMsg: '该会议白名单中未搜索到你的账号，请联系会议主持人',
  activeSpearker: '动态发言人',
  specificSpeaker: '指定发言人',
  spearker: '发言人',
  spearkerT: '输入发言人名称',
  dwAgent: '下载代理安装程序',
  selectN: '选择Node',
  commandT: '请使用 root 或 sudo 运行以下命令',
  toIns: '安装：',
  toUnins: '卸载',
  nodeName: 'Box昵称',
  nodePlaceholder: '选择Box昵称',
  sdiPort: '端口',
  sdiReference: 'SDI端口参考',
  sdiDuplex: 'Agent处于全双工模式时，SDI输入/输出不可用。{ele}请<a>切换到半双工模式</a>再试一次。',
  tvuRes: 'TVU主办',
  resource: '资源',
  region: '机器地区',
  adConfig: '高级配置',
  otDetail: '其他详情',
  ownRes: '自带机器',
  agentTips1: '通过轻量级软件代理无缝集成您自己的机器资源，',
  agentTips2: '在 TVU云调度中托管实时视频路由工作流程',
  agentTips3: '通过安装 TVU代理访问您的 SDI 信号',
  destination: '推流地址',
  Destination: '推流地址',
  // previewPanelV2 三种 panelType（folder/destination/source）对应的 actions / status 段标题 [Claude Code]
  folderActions: '文件夹操作',
  destinationActions: '目标操作',
  sourceActions: '源操作',
  destinationStatus: '目标状态',
  sourceStatus: '源状态',
  encodeProfile: '编解码配置文件',
  newDest: '新推流地址',
  destName: '推流地址名称',
  chartTips: '少于100字符',
  alpSing: '字母排序',
  createSing: '创建时间排序',
  liveOnly: '仅推流中',
  streamIndex: '流索引名',
  pushMedia: '从云调度推流',
  pullMedia: '从云调度拉流',
  publishAcc: '发布到你的社交媒体账号',
  KS: '快手',
  others: '其他',
  other: '其他',
  encodeManage: '编解码配置文件管理',
  encodeName: '编解码配置文件名称',
  operation: '操作',
  inUse: '使用中',
  edit: '编辑',
  duplicate: '复制',
  delete: '删除',
  remove: '移除', // 移除按钮 title 文案 [Claude Code]
  profileName: '文件名称',
  videoEncoder: '视频编码',
  format: '制式',
  advanced: '高级',
  yes: '是',
  no: '否',
  codec: '编码器',
  scale: '比例尺',
  level: '资源级别',
  profile: '配置文件',
  audioEncode: '音频编码',
  sampleRate: '采样率',
  noData: '无数据',
  deleteTip: '确定删除XX文件吗？',
  confirm: '确定',
  deleteSuccess: '删除成功',
  add: '新增',
  passthrough: '跟随输入',
  outputs: '输出',
  micoService: '微服务',
  colorCorrection: '颜色校正',
  useResTips: '你正在使用自己的机器资源',
  share: '分享',
  access: '授权',
  Admin: '管理',
  admin: '用户管理：这些用户/组员有权修改此源及其事件的设置',
  accessT: '授权的组员邮箱',
  selectSubG: '选择子组',
  owner: '所有者',
  done: '完成',
  state: '状态',
  takeLive: '推流：这些用户/组员有权将此源推流',
  recordings: '录制：这些用户/组员有权给此源录制',
  livePreview: '预览：这些用户/组员有权预览此源',
  noUsers: '无用户',
  deleteConfirm: '确认删除{sourceName}源吗？',
  permissionTip: '你无权从此对象移除此设备的分配',
  noPort: '无SDI端口',
  hlsMulti: 'HLS多编解码文件',
  multiProfile: '多编解码文件配置',
  copy: '拷贝',
  dnsTip: '如果你的DNS无法解析原始RUL，可以改用该基于IP的URL。请注意：每次重新启动任务时，IP URL都会发生变化',
  correctTip: '调整视频颜色以提高图像质量。注意：这是一项付费功能。',
  fecRow: 'FEC行数',
  fecCol: 'FEC列数',
  multiChart: '行数乘列数需小于或等于100',
  rows: '行',
  cols: '列',
  select: '选择',
  // deleteProject:'确认删除XX？XX正在使用该项目推流，删除将停止该推流',
  // deleteSource:'确认删除XX？XX正在预览该源，删除将关闭该预览',
  // deleteLiveSource:'确认删除XX？XX正在使用该源推流，删除将停止该推流',
  // deleteRecordSource:'确认删除XX？XX正在录制该源，删除将停止该录制',
  deleCom: '删除确认',
  deleteProject: '确认删除{projectName}？无法恢复。',
  stopDestinaton: '确认停止推流？',
  // folder 卡片停流确认文案：对象是 folder 而非单个 destination [Claude Code]
  stopFolder: '确认停止该 Folder 推流？',
  stopDestinatonWithName: '确认停止{objectName}推流？',
  deleteLiveProject: '确认删除{projectName}？{projectName}正在推流, 删除将在推流停止之后生效',
  deletePreviewSource: '该源正在预览，请先停止预览，再删除该源',
  deleteLiveSource: '确认删除{sourceName}？你正在使用该源推流，删除将停止该推流',
  deleteRecordSource: '确认删除{sourceName}？你正在录制该源，删除将停止该录制',
  transportMode: '传输模式',
  faildOutput: 'URL解析失败，请输入正确的URL或选择一个输出类型',
  faildSourceType: 'URL解析失败，请输入正确的URL或选择一个源类型',
  trialRemain: '试用时长剩余',
  freeTip: '你的云调度试用将于14/8/2024 23:59:59 UTC截止。如有疑问，请联系你的TVU销售代表',
  sourceCreateSuc: 'Object创建成功<br/><a id="view-source-object-click">立即查看</a>',
  sourceCreateFail: 'Object创建失败',
  projectCreatedSuc: 'Object创建成功<br/><a id="view-project-object-click">立即查看</a>',
  projectCreatedFail: '项目创建失败',
  backupSource: '备用源',
  primary: '主源',
  backup: '备用源',
  default: '默认',
  Apply: '应用',
  applySave: '应用并保存',
  resConfig: '默认资源配置',
  previewShutdown: '无直播时15分钟后自动关闭预览',
  shutdownTask: '这是一个组级的配置',
  previewRecovery: '预览恢复',
  recoverReVisting: '若云调度因关闭浏览器自动关闭任务预览，则在浏览器再次打开云调度服务时自动恢复预览',
  tvuAgent: 'TVU代理',
  agentDownloadTips: '如需启用 SDI 输入/输出功能、在您自己的基础设施上部署云调度或管理信号集成和本地资源部署，请先下载并安装 <a href="{url}" target="_blank">TVU代理</a>',
  boxPool: '资源池',
  boxPoolPlaceholder: '选择资源池',
  manageBoxPool: '去<a href="{url}" target="_blank">TVU Home</a>管理资源',
  manageStaticIP: '<a href="{url}" target="_blank">静态IP管理</a>',
  optional: '可选',
  startProject: '推流加载',
  startPreview: '预览加载',
  copyUrl: '复制源路径',
  liveWith: '正在和<span class="liveName" title="正在和{name}推流">{name}</span>推流',
  thumbnail: '缩略图',
  projectName: '项目名称',
  description: '描述',
  cloudBox: '云机',
  phsicalBox: '物理机',
  scopeT: '该项目调色功能已禁用，请开启该功能重新推流后再试',
  broadcastR: '信号调度',
  warining: '警告',
  streamFailed: '推流失败',
  readOnlyWhileStreaming: '源正在推流时无法编辑此项。',
  occur: '发生',
  newEvent: '新增事件',
  event: '事件',
  eventName: '事件名',
  startTimes: '开始时间',
  endTimes: '结束时间',
  selectDT: '选择日期和时间',
  notRepeat: '不重复',
  daily: '每日',
  weekly: '每周',
  monthly: '每月',
  annually: '每年',
  MtoF: '每个工作日（周一至周五',
  custom: '自定义',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  Sunday: '周日',
  January: '一月',
  Febuary: '二月',
  March: '三月',
  April: '四月',
  May: '五月',
  June: '六月',
  July: '七月',
  August: '八月',
  September: '九月',
  October: '十月',
  November: '十一月',
  December: '十二月',
  destType: '推流类型',
  encoderFile: '编码文件',
  videoBit: '视频比特率',
  audioBit: '音频比特率',
  dropFs: '丢帧率',
  month: '月',
  week: '周',
  day: '日',
  agenda: '日程',
  emptyEvent: '暂无events',
  recordingTask: '录制任务已开始，请稍等',
  recording: '录制',
  recordConfig: '录制配置',
  speechTran: '语音转录',
  recordStandard: '请联系你的TVU客户经理了解标准录制功能定价',
  bucket: '存储桶',
  bucketT: '请输入存储桶名',
  facialDetection: '面部识别',
  config: '配置',
  recordTooltip: '录制：事件运行期间开启源录制',
  start: '开始',
  createNewFP: '新建筛选包',
  saveAs: '保存为',
  events: '事件',
  sources: '源',
  online: '在线',
  onlineNoInput: '在线且无输入',
  offline: '离线',
  tvuMediaSource: 'TVU视频源',
  tagFilter: '输入标签筛选',
  manageTag: '管理标签',
  Event: '事件',
  tags: '标签',
  tagName: '标签名',
  Personal: '个人',
  Group: '组',
  noEventPermission: '无权限编辑此事件',
  downloadTip: '下载源时间表',
  importTip: '导出源时间表',
  importS: '导入成功',
  saveMapS: '保存映射关系成功',
  importSchedule: '导入源事件时间表',
  fieldM: '字段映射',
  templateError: '获取错误',
  profileExiste: '文件已存在',
  saveFail: '保存失败',
  tagListError: '获取标签列表失败',
  saveS: '保存成功',
  saveF: '保存失败',
  copyS: '复制成功',
  selectTag: '请选择标签',
  payError: '打开订阅管理失败',
  enterBucket: '请输入存储桶名',
  enterRegion: '请输入地区',
  noPermissionDT: '无权限删除此标签',
  unlinkS: '解绑成功',
  unlinkF: '解绑失败',
  linkDevice: '请选择一个绑定设备',
  assignObj: '已从对象分配设备',
  validDomain: '请输入有效的域名',
  isspInvalid: 'ISSP URL无效',
  selectServer: '请选择服务器',
  completeUrl: '请输入完整URL',
  correctUrl: '请输入正确的URL',
  invalidKey: '无效流密钥',
  domainChar: '域名包含1-18位字符',
  avaKey: '请输入可用密钥',
  deviceFaildTry: '设备激活失败，请稍后重试',
  sdiInactive: 'SDI节点不可用状态',
  selectNodePort: '请选择节点和端口的SDI',
  selectResourceUrl: '请输入资源地址',
  inputSourceName: '请输入 Source Name',
  selectRegion: '请选择地区',
  selectPbox: '请选择物理机',
  addFail: '新增失败',
  srtUrlInvaild: '无效SRT URL',
  operateS: '操作成功',
  deleteS: '删除成功',
  inputProfile: '请输入文件名',
  selectOutputA: '请选择输出账户',
  notSupport: '浏览器不支持复制',
  copyFromPro: '对象{projectName}信息复制成功',
  startWait: '正在启动，请稍等',
  liveWithS: '源{sourceObjectName} 正在与该项目推流',
  notSupportSDI: '云机不支持SDI源',
  noAvailableDest: '没有可用的有效输出地址，',
  pcheck: '请检查',
  checkPConfig: '输出项目配置',
  switchQuick: '切换频繁，请稍后片刻重试',
  StopS: '停止成功',
  selectBackup: '请选择备份源',
  primaryNoEx: '主源不存在',
  copyFromObj: '对象{tangibleName}信息复制成功',
  stopFirst: '该源正与{livePeerName}推流，请先停止该推流',
  notLiveOffline: '该源当前离线，不能推流',
  recordingS: '录制任务已开始，请稍等',
  editSu: '编辑成功',
  picUpload: '请选择图片上传',
  picTooLarge: '图片太大，请选择其它图片',
  selectOutputOne: '请至少选择一个输出',
  downloadHome: '在TVU Home下载',
  notShow: '不再显示',
  Original: '原片效果',
  After: '调色后效果',
  yuvC: 'YUV 控制',
  rgbC: 'RGB 控制',
  autoC: '自动白平衡:',
  yGain: '亮度增益',
  chroma: '色度',
  hue: '色调',
  yOffset: '亮度偏移',
  gamma: '伽马',
  reset: '重置',
  resetAll: '全部重置',
  vector: '矢量示波器',
  waveform: 'RGB直方图',
  rGain: 'R增益',
  rOffset: 'R偏移',
  gGain: 'G增益',
  gOffset: 'G偏移',
  bGain: 'B增益',
  bOffset: 'B偏移',
  uploadRP: '上传参考图',
  uploadS: '上传成功',
  uploadE: '上传失败',
  uploading: '上传中',
  preUpload: '准备上传中',
  available: '可用的',
  occupied: '已占用',
  ratio: '宽高比',
  uhdTip: 'UHD源需要额外资源解码。若输入源的分辨率高于1920x1080，请启用该功能',
  spearkerTip: '只录制选定用户的音频',
  isolatedAudio: '独立音频',
  noPermissonRemoveObj: '您无权从此对象中移除此设备的分配。',
  removeAssign: '你确定要从此对象中移除设备的分配吗？',
  selectSourceType: '请选择源类型',
  modifySourceType: '如果修改源类型，请先停止预览或推流。',
  unlinkSourceType: '如果从此对象中移除此设备的分配，请先停止预览或推流。',
  assignSourceType: '如果从此对象中修改此设备的分配，请先停止预览或推流。',
  selectFileCom: '从您的计算机中选择文件',
  selectAll: '全选',
  selectSDIPort: '请选择SDI端口',
  noSDIDeviceDetected: '未检测到SDI设备',
  QR: '二维码',
  QRToken: '复制令牌',
  QRCode: '复制二维码',
  QRScan: '使用 TVU Anywhere 扫描二维码',
  anywhere1: '1. 在您的设备上安装“TVU Anywhere”',
  anywhere2: '2. 打开‘TVU Anywhere’应用',
  anywhere3: '3. 选择‘扫描’以扫描或上传此二维码',
  anywhere4: '4. 您的 TVU Anywhere 设备将出现在',
  anywhere5: '‘可用’设备列表中',
  addTVUDevice: '添加 TVU Anywhere 设备',
  openMP: '确定打开支付管理吗？',
  manageSub: '订阅管理',
  domain: '域名',
  enterDomain: '请输入域名',
  key: '密钥',
  enterKey: '请输入密钥',
  enterMeeting: '请输入会议ID',
  enterDN: '请输入域名',
  domianName: '域名',
  switchLiveT: '当前项目正在和 <span style="color: #E56464;">{sourceObjectName}</span>推流。</br>你确定要使用 <span style="color: #E56464;">{objectName}</span>吗?',
  switchLiveF: '当前文件夹正在和 <span style="color: #E56464;">{sourceObjectName}</span>推流。</br>你确定要使用 <span style="color: #E56464;">{objectName}</span>吗?',
  vaildDomain: '请输入合法域名',
  portTips: '请输入40000-65000之间的端口号',
  eventNameTip: '请输入事件名称',
  participantName: '参与者名称',
  enterTips: '请输入{type}',
  switcher: '当前切换器正在启动，请稍候',
  NDIName: 'NDI主机机器名',
  NDISourceName: 'NDI流名称',
  joinZoom: '加入Zoom会议',
  passcode: '密码',
  publicIp: '当前显示公共 IP 地址',
  privateIp: '当前显示本地 IP 地址',
  ipBasedUrl: '基于IP的URL:',
  baseUrlTip1: 'DNS如无法解析域名，请用此IP地址。',
  baseUrlTip2: '请注意：每次任务重启时，IP地址会更新。',
  baseUrlTip3: '每次任务重启时会变化', // 中文翻译 [Claude Code]
  srtUrl: '输入SRT Caller链接',
  rtspUrl: '输入RTSP入口点链接',
  rtmpUrl: '输入RTMP入口点链接',
  frameConversion: '运动补偿帧速率转换',
  frameConversionTips: '通过使用高级运动估计转换帧速率来增强视频流畅度。<br/>注意：由于计算要求高，因此这是一项付费功能。',
  disabledFrameConversion: '直通输出不支持运动补偿帧速率转换。',
  disabledColorCorrection: '直通输出不支持颜色校正。',
  enableColorCorrection: '你必须在源配置页中启用颜色校正功能。',
  applyColorCorrection: '你必须先开始解码视频，然后再应用色彩校正。',
  message: '提示',
  paidFeature: '这是一个付费功能。请联系TVU技术支持。',
  Sorting: '排序',
  enterProjectName: '输入项目名称',
  copyright: '版权',
  terms: '条款协议',
  policy: '隐私政策',
  license: '内容许可',
  startLiveOccupied: '{desName}已被项目{prjName}占用',
  destCount: '推流数量',
  passthroughTips: '如果启用实时跟随输入，则此项目中目标的所有编码配置文件都将遵循项目',
  microTip: '需要重启才会生效',
  microMsTip: '设置的毫秒不可用',
  projectConfig: '项目配置',
  microservice: '微服务',
  settings: '设置',
  basicInfo: '名称&标签',
  streamConfig: '流配置',
  resources: '资源',
  continue: '继续',
  autoPreview: '自动预览',
  graphics: '图形',
  srtLatencyNote: '如果您的URL包含延迟参数，请确保以微秒(μs)为单位指定',
  switchForBlack: '检测到黑帧时切换备份源',
  disasterRecovery: '灾难恢复',
  selectbackup: '选择备用源',
  ignoreInitialTransmission: '忽略初始传输',
  ignoreInitialTransmissionTip: '新流启动的前几秒出现解码错误属于正常现象。此设置可防止在源初始化期间触发误切换。',
  cooldownPeriod: '冷却时间',
  cooldownPeriodTip: '两次自动切换之间的最短间隔时间',
  lowBitrateThreshold: '低码率阈值 (Mbps)',
  lowBitrateThresholdTip: '活动源的最低可接受码率。当传入码率低于此值时，系统将开始监控并准备切换到备用源。',
  lowBitrateSwitchDelay: '低码率切换延迟',
  lowBitrateSwitchDelayTip: '码率持续低于阈值达到指定秒数后，系统将自动切换到备用源。增大此值可避免因短暂码率波动触发切换。',
  recoveryDuration: '恢复持续时长',
  recoveryDurationTip: '码率高于阈值持续指定时长后，系统才会切回主源',
  seconds: '秒',
  blackFrameDetection: '黑帧检测',
  detectionMode: '检测模式',
  bitrateMode: '码率模式',
  blackFrameMode: '黑帧模式',
  manualOnlyMode: '仅手动',
  manualOnlyTip: '仅手动模式，不做任何监测。',
  blackFrameSeamlessTip: '要使用基于黑帧的自动切换，请在目标 destination 上启用 Seamless Switching（无缝切换）。',
  autoFailover: '自动故障转移',
  emailNotify: '邮件通知',
  comingSoon: '即将上线...', // bitrate 模式邮件通知的 coming soon 提示 [Claude Code]
  detectBlackToBackPreText: '在检测到',
  detectBlackToBackAftText: '毫秒黑帧时，切换到备用源',
  autoRecovery: '自动恢复',
  detectBlackPreText: '检测到', // 中文翻译 [Claude Code]
  detectBlackAftText: '毫秒黑帧后切换至备用源。', // 中文翻译 [Claude Code]
  detectBlackToMainPreText: '主源从黑帧状态恢复且保持',
  detectBlackToMainAftText: '毫秒后，切回主源',
  // 容灾保存前置校验提示文案（validateDisaster 六条规则） [Claude Code]
  bfRequireFailoverOrEmail: '黑帧模式下必须至少开启自动故障转移或邮件通知其中之一',
  brRequireFailoverOrEmail: '码率模式下必须至少开启自动故障转移或邮件通知其中之一',
  bfFailoverDurationRequired: '黑帧模式下必须填写黑帧持续时长',
  bfRecoveryDurationRequired: '开启自动恢复时必须填写恢复时长',
  bfEmailRequired: '开启邮件通知时必须至少选择一个通知邮箱',
  drBackupSourceRequired: '开启容灾时必须选择备用源',
  selectEmail: '选择邮件',
  tvuPick: '让TVU为我选择',
  selfPick: '自己选择',
  tvuPickTip: 'TVU将自动选择最佳的可用区域，以确保您的任务及时启动。',
  selfPickTip: '对于喜欢手动选择所需区域的高级用户。',
  staticIp: '静态IP',
  Total: '总计',
  restartEffect: '重启后生效',
  projectDestNum: '项目包含的推流地数量',
  otherDetail: '其他详情',
  liveWithDest: '正在和{destNum}个地址推流',
  output: '输出',
  Transitioning: '进度',
  restoreConfig: '重置上次配置',
  destinationIdOrName: '输出的ID或名称',
  stopProject: '确认停止该项目？',
  stopProjectWithName: '确认停止{objectName}项目？',
  stopFolderWithName: '确认停止文件夹 {objectName} 推流？', // folder 顶层 stop 弹窗（MH-2633）[Claude Code]
  stopDestWithName: '确认停止输出 {objectName}？', // destination 顶层 stop 弹窗（MH-2633）[Claude Code]
  switchLiveD: '当前输出正在和 <span style="color: #E56464;">{sourceObjectName}</span>推流。</br>你确定要使用 <span style="color: #E56464;">{objectName}</span>吗?',
  switchFolderLiveD: '当前 Folder <span style="color: #E56464;">{folderName}</span> 正在和 <span style="color: #E56464;">{currentSourceName}</span> 推流。</br>你确定要切换到 <span style="color: #E56464;">{newSourceName}</span> 吗?',
  projectConfigs: '项目配置',
  previewing: '预览（源导入+预览）',
  ingesting: '采集（源导入）',
  ingesting1: '接收',
  ingesting2: '接收中',
  previewUsedBy: '预览由 {email} 使用，时间 {time}(UTC)',
  receiveUsedBy: '接收由 {email} 使用，时间 {time}(UTC)',
  liveUsedBy: '推流由 {email} 使用，时间 {time}(UTC)',
  outputPreview: '推流时预览源',
  noLiveD: '没有推流',
  liveD: '有{count}个推流',
  Previewing: '预览',
  Ingesting: '采集',
  Standby: '待机',
  noStopIngesting: '正在推流，无法停止采集',
  keepIngesting: '此源正在被输出使用。请先停止输出，然后再停止输入',
  sdiTipsRef: 'Ref 端口不能用于 SDI 信号传输',
  sourceSearchP: '源的名称/PID',
  projectSearchP: '项目ID/名称',
  destinationSearchP: '输出/文件夹名称',
  otherSetting: '其他设置',
  stopLive: '停止推流',
  smpteTip: ` SMPTE ST 2022-7:定义RTP数据报<br>
              的无缝保护交换的标准。它使发<br>
              送器发送两个相同的数据包流冗<br>
              余网络路径，允许接收方重构一<br>
              个单一的、不间断的输出流逐包<br>
              的基础-即使一条路径失败
              <a href="https://www.smpte.org/?utm_source=chatgpt.com"
                 target="_blank"> 更多</a><br>
              <br>
              使用要求:<br>
              启用了2022-7的源只能路由到<br>
              启用了2022-7的目的地。<br>`,
  createByMe: '我创建的',
  selfHost: '自己托管',
  autoShutIdle: '自动关闭空闲输入',
  autoShutIdleText: '如果输入源持续活动 15 分钟或更长时间但仍未开始直播，系统将自动停止该输入源。',
  stopNoNeed: '不再需要输出时，停止输入。',
  stopNoNeedText: '当所有依赖于此输入源的输出源都关闭时，该输入源也会关闭。',
  audioSyncLicense: 'Audience Measurement Watermarking 授权码',
  audioSyncLicenseTip: '当 destination 开启 Audience Measurement Watermarking 时，必须配置该 License。',
  tvuHostedServerLocation: 'TVU 托管服务器位置',
  goMA: '去Media Analyzer',
  noAccessWF: '用户没有权限访问{wf}服务。',
  workflowMonitor: 'MediaMesh Monitor',
  generateInfo: '生成并复制故障信息给TVU支持',
  batchSelect: '批量选择',
  batchExit: '退出',
  nSelected: '已选择 {n} 项',
  createFolder: '创建文件夹',
  hdmiSdiWarning: 'HDMI端口不能用于SDI信号传输', // SDI HDMI 端口警告 [Claude Code]
  ultraStudioSdiWarning: 'UltraStudio Monitor 3G 不支持SDI输入', // UltraStudio SDI 输入警告 [Claude Code]
  interact: '交互', // HTML Source 交互按钮 [Claude Code]
  interactTip: '(开启源预览后可使用此功能)', // 交互功能提示 [Claude Code]
  ndiDiscoveryBy: '发现方式', // NDI 发现方式列标题 [Claude Code]
  audioOnly: '仅音频', // 仅音频开关标签 [Claude Code]
  mxlInputVideoUuid: 'MXL输入视频共享内存UUID', // MXL 视频共享内存 UUID 标签 [Claude Code]
  mxlInputAudioUuid: 'MXL输入音频共享内存UUID', // MXL 音频共享内存 UUID 标签 [Claude Code]
  mxlVideoDomainPath: 'MXL视频共享内存域路径', // MXL 视频共享内存域路径标签 [Claude Code]
  mxlAudioDomainPath: 'MXL音频共享内存域路径', // MXL 音频共享内存域路径标签 [Claude Code]
  enterContent: '请输入内容', // 通用输入占位符 [Claude Code]
  pleaseEnterContent: '请输入内容', // 表单校验提示 [Claude Code]
  errorMonitor: '错误监控', // 错误监控标题 [Claude Code]
  operationalLogs: '操作日志', // 操作日志标题 [Claude Code]
  errors: '个错误', // 错误数徽章 [Claude Code]
  warnings: '个警告', // 警告数徽章 [Claude Code]
  enterScheduleName: '请输入排程名称', // 排程名称输入占位符 [Claude Code]
  time: '时间', // 时间标签 [Claude Code]
  noSourceSelected: '未选择源', // 未选择源占位文本 [Claude Code]
  browse: '浏览', // 浏览按钮 [Claude Code]
  noDestSelected: '未选择目标', // 未选择目标占位文本 [Claude Code]
  addDescription: '添加描述', // 添加描述占位符 [Claude Code]
  selectSource: '选择源', // 选择源弹窗标题 [Claude Code]
  selectDestination: '选择目标', // 选择目标弹窗标题 [Claude Code]
  editSchedule: '编辑排程', // 编辑排程弹窗标题 [Claude Code]
  addSchedule: '新增排程', // 新增排程弹窗标题 [Claude Code]
  scheduleDeletedSuccess: '排程删除成功', // 排程删除成功 [Claude Code]
  scheduleDeleteFailed: '排程删除失败', // 排程删除失败 [Claude Code]
  scheduleUpdatedSuccess: '排程更新成功', // 排程更新成功 [Claude Code]
  scheduleCreatedSuccess: '排程创建成功', // 排程创建成功 [Claude Code]
  scheduleSaveFailed: '排程保存失败', // 排程保存失败 [Claude Code]
  scheduleCreateFailed: '排程创建失败', // 排程创建失败 [Claude Code]
  success: '成功', // 成功通知标题 [Claude Code]
  error: '错误', // 错误通知标题 [Claude Code]
  today: '今天', // 今天按钮 [Claude Code]
  noScheduledRoutes: '暂无排程路由', // 无排程路由提示 [Claude Code]
  scheduleRoute: '排程路由', // 排程路由按钮 [Claude Code]
  scheduleARoute: '排程一条路由', // 排程一条路由按钮 [Claude Code]
  download: '下载', // 下载按钮 [Claude Code]
  gotIt: '知道了', // 知道了按钮 [Claude Code]
  noResultsFound: '未找到结果', // 未找到结果 [Claude Code]
  folder: '文件夹', // 文件夹标签 [Claude Code]
  added: '已添加', // 已添加标签 [Claude Code]
  allLoaded: '已全部加载', // 已全部加载提示 [Claude Code]
  Sun: '日', // 星期日缩写 [Claude Code]
  Mon: '一', // 星期一缩写 [Claude Code]
  Tue: '二', // 星期二缩写 [Claude Code]
  Wed: '三', // 星期三缩写 [Claude Code]
  Thu: '四', // 星期四缩写 [Claude Code]
  Fri: '五', // 星期五缩写 [Claude Code]
  Sat: '六', // 星期六缩写 [Claude Code]
  doesNotRepeat: '不重复', // 不重复选项 [Claude Code]
  everyWeekday: '每个工作日（周一至周五）', // 每个工作日选项 [Claude Code]
  Day: '日', // 日视图 [Claude Code]
  Week: '周', // 周视图 [Claude Code]
  Month: '月', // 月视图 [Claude Code]
  sourceUrlName: '源URL/名称', // 源URL/名称列头 [Claude Code]
  severity: '严重程度', // 严重程度列头 [Claude Code]
  searchByEmail: '按邮箱搜索', // 按邮箱搜索占位符 [Claude Code]
  end: '结束', // 日期范围结束占位符 [Claude Code]
  object: '对象', // 对象列头 [Claude Code]
  errorType: '错误类型', // 错误类型列头 [Claude Code]
  timestamp: '时间戳', // 时间戳列头 [Claude Code]
  loadingText: '加载中...', // 加载中提示 [Claude Code]
  operated: '操作了', // 操作了 [Claude Code]
  noMoreData: '没有更多数据', // 没有更多数据提示 [Claude Code]
  noErrorLogsFound: '未找到错误日志', // 未找到错误日志提示 [Claude Code]
  noPermissionDeleteTags: '您没有权限删除标签。', // 无权删除标签提示 [Claude Code]
  feedbackToTvu: 'TVU Mediahub 问题反馈', // 问题反馈弹窗标题 [Claude Code]
  title: '标题', // 标题表单标签 [Claude Code]
  enterTitle: '请输入标题', // 输入标题占位符 [Claude Code]
  enterDescription: '请输入描述', // 输入描述占位符 [Claude Code]
  create: '创建', // 创建按钮 [Claude Code]
  folderName: '文件夹名称', // 文件夹名称 [Claude Code]
  enterFolderName: '请输入文件夹名称', // 输入文件夹名称占位符 [Claude Code]
  addDestination: '添加目标', // 添加目标 [Claude Code]
  updateFolderSuccess: '更新文件夹成功', // 更新文件夹成功 [Claude Code]
  successCreateFolder: 'Object创建成功<br/><a id="view-project-object-click">立即查看</a>', // 创建文件夹成功，含查看链接 [Claude Code]
  failedCreateFolder: 'Object创建失败', // 创建文件夹失败 [Claude Code]
  failedBindDestinations: '绑定目标到文件夹失败', // 绑定目标到文件夹失败 [Claude Code]
  colDestination: '目标', // 表头：目标 [Claude Code]
  colStatus: '状态', // 表头：状态 [Claude Code]
  colSource: '源', // 表头：源 [Claude Code]
  colAction: '操作', // 表头：操作 [Claude Code]
  errorRate8s: '错误率(8秒):', // 8秒错误率 [Claude Code]
  errorRate1s: '错误率(1秒):', // 1秒错误率 [Claude Code]
  lineQuality8s: '线路质量(8秒):', // 8秒线路质量 [Claude Code]
  lineQuality1s: '线路质量(1秒):', // 1秒线路质量 [Claude Code]
  videoInput: '视频输入:', // 视频输入 [Claude Code]
  inputFormat: '输入格式:', // 输入格式 [Claude Code]
  delayS: '延迟（秒）', // 延迟（秒）[Claude Code]
  bitrateMbps: '码率（Mbps）', // 码率（Mbps）[Claude Code]
  defaultBtn: '默认', // 默认按钮 [Claude Code]
  resetToLast: '恢复上次', // 恢复上次按钮 [Claude Code]
  applySuccess: '应用成功', // 应用成功 [Claude Code]
  primarySetting: '主路设置', // 主路设置 [Claude Code]
  secondarySetting: '备路设置', // 备路设置 [Claude Code]
  labelNic: '网卡', // 网卡标签 [Claude Code]
  labelSourceBroadcastIp: '源广播IP', // 源广播IP标签 [Claude Code]
  labelSourceBroadcastPort: '源广播端口', // 源广播端口标签 [Claude Code]
  labelSourceIp: '源IP', // 源IP标签 [Claude Code]
  allLevels: '所有级别', // 所有级别 [Claude Code]
  objectInactive: '对象未激活', // 对象未激活 [Claude Code]
  domainNamePlaceholder: '域名', // 域名占位符 [Claude Code]
  streamKeyPlaceholder: '推流密钥', // 推流密钥占位符 [Claude Code]
  none: '无', // 无 [Claude Code]
  srtConnectionStatus: 'SRT连接状态:', // SRT连接状态 [Claude Code]
  Waiting: '等待中', // SRT 状态：等待 [Claude Code]
  Sending: '推流中', // SRT 状态：推流中 [Claude Code]
  Accepted: '已接受', // SRT 状态：已接受 [Claude Code]
  Rejected: '已拒绝', // SRT 状态：已拒绝 [Claude Code]
  Closed: '已停止', // SRT 状态：已停止（Other tooltip 子段标题，i18n 值改"已停止"但 key 名保留 Closed 对齐 SRT 协议 CLOSED 桶）[Claude Code]
  Other: '其他', // SRT 状态聚合 pill 标签：Closed + Rejected [Claude Code]
  sendingSinceLine: '正在向 {target} 推流，自 {time} 起', // SRT Sending tooltip 行描述：target=ip:port [Claude Code]
  stoppedSendingSinceLine: '已停止向 {target} 推流，自 {time} 起', // SRT Closed tooltip 行描述 [Claude Code]
  rejectedAtLine: '已拒绝 {target}，于 {time}', // SRT Rejected tooltip 行描述 [Claude Code]
  recentActivity: '近期动态', // 状态 tooltip 表头 [Claude Code]
  waitingForCaller: '正在等待 caller 连接', // SRT Listener waiting 提示 [Claude Code]
  waitingToListener: '正在等待连接到 listener', // SRT Caller waiting 提示 [Claude Code]
  operationLog: '操作日志', // 状态 tooltip 操作日志链接 [Claude Code]
  addEvent: '添加日程', // 添加日程标题 [Claude Code]
  editRecurringEvent: '重复日程', // 编辑重复日程标题 [Claude Code]
  deleteRecurringEvent: '删除重复日程', // 删除重复日程标题 [Claude Code]
  deleteEvent: '删除日程', // 删除日程标题 [Claude Code]
  thisEvent: '此日程', // 此日程单选项 [Claude Code]
  thisAndFollowingEvents: '此日程及后续日程', // 此日程及后续日程单选项 [Claude Code]
  allEvents: '所有日程', // 所有日程单选项 [Claude Code]
  endDate: '结束日期', // 结束日期 placeholder [Claude Code]
  alwaysOn: '始终开启', // 永久启用 schedule（form 勾选 + pill 状态）[Claude Code]
  endsAt: '{time} 结束', // pill 上"12:00 结束" 的可翻译模板 [Claude Code]
  endTimeMustBeLaterThanStart: '结束时间必须晚于开始时间', // 时段非法提示 [Claude Code]
  deleteEventConfirm: '确定要删除此日程吗？', // 删除日程确认提示 [Claude Code]
  setDefaultSettingConfirm: '是否将此访问配置设为默认？', // 设为默认配置确认提示 [Claude Code]
  dontRemindNextTime: '下次不再提醒', // 下次不再提醒 [Claude Code]
  customRecurrence: '自定义重复', // 自定义重复标题 [Claude Code]
  repeatEvery: '重复频率', // 重复频率标签 [Claude Code]
  repeatOn: '重复日期', // 重复日期标签 [Claude Code]
  ends: '结束', // 结束标签 [Claude Code]
  never: '永不', // 永不单选项 [Claude Code]
  onLabel: '指定日期', // 指定日期单选项 [Claude Code]
  afterLabel: '之后', // 指定次数单选项 [Claude Code]
  occurrences: '次', // 次数单位 [Claude Code]
  customDots: '自定义...', // 自定义（带省略号）选项 [Claude Code]
  Year: '年', // 年单位 [Claude Code]
  monthlyCustomOne: '按日期重复', // 月重复选项一 [Claude Code]
  monthlyCustomTwo: '按星期重复', // 月重复选项二 [Claude Code]
  idle: '空闲', // 空闲状态 [Claude Code]
  clickToRouteHere: '点击路由到此处', // 路由点击提示 [Claude Code]
  passthroughNoEffect: '不会对跟随输入目标生效。', // 跟随输入目标不生效提示 [Claude Code]
  alreadyRouted: '已路由', // 已路由标题 [Claude Code]
  alreadyRoutedMsg: '{source} 已路由到 {dest}', // 已路由提示信息 [Claude Code]
  viewMode: '视图模式', // 视图模式标题 [Claude Code]
  viewModeCard: '卡片', // 卡片视图模式 [Claude Code]
  viewModeCompact: '紧凑', // 紧凑视图模式 [Claude Code]
  viewModeList: '列表', // 列表视图模式 [Claude Code]
  viewModeXYGrid: 'XY Grid', // XY Grid 视图模式 [Claude Code]
  selectDestinationFor: '为"{name}"选择目标', // 为指定源选择目标 [Claude Code]
  selectDestinationTo: '选择目标到"{name}"', // 选择目标到指定文件夹 [Claude Code]
  exitFilter: '退出筛选', // 退出筛选按钮 [Claude Code]
  showingConnectedDestinations: '显示 {total} 个已连接的目标', // 显示已连接的目标数量 [Claude Code]
  showingConnectedSources: '显示 {total} 个已连接的源', // 显示已连接的源数量 [Claude Code]
  refresh: '刷新', // 刷新按钮 [Claude Code]
  destinations: '目标', // 目标列表标题 [Claude Code]
  startLive: '开始', // 开始推流按钮 [Claude Code]
  noDestInFolder: '此文件夹内暂无目标', // 文件夹无目标空状态 [Claude Code]
  deleteFolder: '删除文件夹', // 删除文件夹标题 [Claude Code]
  deleteFolderConfirm: '确定要删除此文件夹吗？<br/>文件夹内的目标不会被删除。', // 删除文件夹确认 [Claude Code]
  apiLogTitle: 'API 日志', // API 日志页标题 [Claude Code]
  apiLogTotal: '共 {count} 条请求', // 请求总数 [Claude Code]
  apiLogRefresh: '刷新', // 刷新按钮 [Claude Code]
  apiLogExport: '导出 CSV', // 导出按钮 [Claude Code]
  apiLogClear: '清空', // 清空按钮 [Claude Code]
  apiLogPath: '接口路径', // 接口路径列 [Claude Code]
  apiLogStatus: '状态码', // 状态码列 [Claude Code]
  apiLogStartTime: '开始时间', // 开始时间列 [Claude Code]
  apiLogEndTime: '结束时间', // 结束时间列 [Claude Code]
  apiLogDuration: '耗时(ms)', // 耗时列 [Claude Code]
  apiLogResult: '结果', // 结果列 [Claude Code]
  apiLogEmpty: '暂无请求记录，请先操作页面产生请求', // 空状态提示 [Claude Code]
  apiLogNoData: '暂无数据可导出', // 无数据导出提示 [Claude Code]
  apiLogSlowOnly: '仅慢接口 (>1s)' // 慢接口筛选 [Claude Code]
}
